import { BaseQueryFn, createApi, FetchArgs, fetchBaseQuery, FetchBaseQueryError, FetchBaseQueryMeta } from '@reduxjs/toolkit/query/react'
import { AdapterConfigureGenerico } from '../../AdapterConfigureGenerico'
import { EndpointBuilder } from '@reduxjs/toolkit/dist/query/endpointDefinitions'
import { usuariosautoinventario } from './usuariosautoinventario'

export const authApi = createApi({
    reducerPath: 'authApi',
    baseQuery: fetchBaseQuery({
        baseUrl: AdapterConfigureGenerico.URL_BASE_AUTH,
        prepareHeaders: (headers) => {
            headers.set('Content-Type', 'application/json')
            headers.set('request-decrypt-response', 'true')
            return headers
        },
    }),
    tagTypes: ['usuariosautoinventario'],
    endpoints: (build) => ({
        ...usuariosautoinventario(build),
    })
})

export type AuthApiBuilder = EndpointBuilder<
    BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError, {}, FetchBaseQueryMeta>,
    'usuariosautoinventario',
    'authApi'
>;

export const {
    useVerifyAutoInventarioMutation,
} = authApi
